export default "__VITE_ASSET__BVUaY13___"